import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { scrollToTop } from "../lib/scroll";

export default function ScrollToTop() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    scrollToTop({ immediate: true });
  }, [pathname, search]);

  return null;
}
